import { render, staticRenderFns } from "./AiBookSysVip.vue?vue&type=template&id=130f214a&scoped=true"
import script from "./AiBookSysVip.vue?vue&type=script&lang=js"
export * from "./AiBookSysVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "130f214a",
  null
  
)

export default component.exports